import React from 'react';

import CollapseBlock    from '../../../../components/containers/CollapseBlock';
import { GalleryImage } from '../../../../components/sliders/GallerySlider/components';

const renderCollapsedBlock = function(data, index, options) {

  return (
    <section key={index}>
      <div className={'container'}>
        {data.CONTENT.map((block, blockIndex) => (
          <CollapseBlock
            key={blockIndex}
            label={block.LABEL}
            open={options?.isOpen}
            onToggle={options?.onToggle}
          >
            <div dangerouslySetInnerHTML={{ __html: block.CONTENT }} />
            {block?.IMAGES?.length > 0 && (
              <div className={'images_container'}>
                {block.IMAGES.map((imageSrc, index) => (
                  <GalleryImage
                    alt={block.LABEL}
                    src={imageSrc}
                    key={index}
                    size={240}
                    type={'image'}
                  />
                ))}
              </div>
            )}
          </CollapseBlock>
        ))}
      </div>
    </section>
  );
};

export default renderCollapsedBlock;